import './resources/styles/theme.scss'

import log from 'salvo-lite/log'
import context from 'salvo-lite/context'
import Theme from './resources/scripts/Theme'
// import Swup from 'swup'
// import SwupMergeHead from './resources/scripts/helpers/SwupMergeHead'
// import swupGaPlugin from 'swup/plugins/swupGaPlugin'
// import swupGtmPlugin from 'swup/plugins/swupGtmPlugin'

import 'dom4'

// const swup = new Swup({
//     debugMode: true,
//     LINK_SELECTOR: 'a[href^="/"]:not([data-no-swup]):not([class^="wistia-pdopover"]), a[href^="#"]:not([data-no-swup]), a[xlink\\:href]'
// })
// swup.usePlugin(SwupMergeHead, { runScripts: true })
// swup.usePlugin(swupGaPlugin, { runScripts: true })
// swup.usePlugin(swupGtmPlugin, { runScripts: true })
// window.swup = swup

context.setTemplate(window.SALVO_BINDINGS.template)

var theme = new Theme()

theme.registerComponents()
theme.registerPages()

log.debug('Main', 'Ready!')

document.addEventListener('shopify:section:load', e => {
    theme = new Theme()
    theme.registerComponents()
    theme.registerPages()
})

document.addEventListener('swup:contentReplaced', event => {
    if (document.querySelector('#MainContent') && document.querySelector('#MainContent').dataset.template) {
        window.SALVO_BINDINGS.template = document.querySelector('#MainContent').dataset.template
    }
    context.setTemplate(window.SALVO_BINDINGS.template)
    theme.registerComponents()
    theme.registerPages()
    window.dispatchEvent(new Event('load'))
})



// WEBPACK FOOTER //
// ./src/main.js